export const FLOATING_PHOTO_WIDTH = 150;
export const FLOATING_PHOTO_HEIGHT = 200;
